import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../../tek.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'

import Headerbutton from "../../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import luxs from "../../../../../../assets/img/LUX_EMPODERADA.png";
import chronos from "../../../../../../assets/img/chronos/chronos-normal.png";

function StepTekSeven(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (

        <div className={"containerStartTekTwo wrapper history tek-ko"}>
              <div className={"insideTek boxed"}>
                  <Headerbutton  saveAndContinue={saveAndContinue}  />
              </div>
              <div className={"container-history boxed"}>
                  <img className={"character character--lux character--center character--center--left"} src={luxs} alt={""} />
                  <img className={"character character--chronos character--center character--center--right"} src={chronos} alt={""} />
                  <div className={"container-dialogue"}>
                      <div className={"dialogue-content-text"}>
                          <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('tek.itin2.chronos1')}}></p>
                      </div>
                      <div className={"dialogue-buttons"}>
                          <div className="left margin-right-auto">
                              <Button
                                icon={<LeftOutlined />}
                                type={"link"}
                                onClick={() => props.goTo(7)}
                              >
                                  {t("atras")}
                              </Button>
                          </div>
                          <div className="right">
                              <Button icon={<ArrowRightOutlined />}
                                      onClick={() =>  history.push("/admin/tek-instructions")}
                                      type={"primary"}
                                      className="primaryButton"
                              >
                                  {t("gotoq")}
                              </Button>
                          </div>
                      </div>
                      <p className={"dialogue-name"}>
                          <strong>LUX</strong>
                      </p>
                  </div>
            </div>
        </div>

    )
}

export default withTranslation()(StepTekSeven);
